import React from 'react';
import { PrimaryButton } from '@beeline.com/bp-design-system/src/components/Button/Button';

export const MissingPage: React.FC<React.PropsWithChildren<unknown>> = () => {
  const reload = () => {
    window.location.reload();
  };
  return (
    <div style={{ maxWidth: 500, margin: '200px auto 0 auto', textAlign: 'center' }}>
      <div>
        <SafetyIcon />
      </div>
      <h3>This page isn't working</h3>
      <div>
        <PrimaryButton.Contained onClick={reload} style={{ margin: '24px auto' }}>
          Reload Page
        </PrimaryButton.Contained>
      </div>
    </div>
  );
};

const SafetyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="92"
    height="92"
    focusable="false"
    role="presentation"
    viewBox="0 0 92 92"
  >
    <g fill="none" fillRule="evenodd">
      <g fill="#0B77E3" fill-opacity=".2">
        <path d="M46 82c19.882 0 36-16.118 36-36S65.882 10 46 10 10 26.118 10 46s16.118 36 36 36z" />
      </g>
      <g>
        <path
          fill="#005CB9"
          fillRule="nonzero"
          d="M80.964 71.575A3 3 0 0 1 78.324 76H13.676a3 3 0 0 1-2.64-4.425L43.36 11.681a3 3 0 0 1 5.28 0l32.324 59.894zM46.88 12.631a1 1 0 0 0-1.76 0L12.796 72.525a1 1 0 0 0 .88 1.475h64.648a1 1 0 0 0 .88-1.475L46.88 12.631z"
        />
        <path
          fill="#FFF"
          d="M46.88 12.63l32.324 59.895a1 1 0 0 1-.88 1.475H13.676a1 1 0 0 1-.88-1.475L45.12 12.631a1 1 0 0 1 1.76 0z"
        />
        <path
          fill="#1369BE"
          d="M45.98 35.64a2.666 2.666 0 0 1 2.662 2.816l-.868 15.467A1.777 1.777 0 0 1 46 55.6a1.78 1.78 0 0 1-1.777-1.677l-.9-15.468a2.66 2.66 0 0 1 2.657-2.815zm-2.9 25.72c0-1.6 1.28-2.96 2.88-2.96 1.64 0 2.96 1.36 2.96 2.96 0 1.6-1.32 2.92-2.96 2.92-1.6 0-2.88-1.32-2.88-2.92z"
        />
      </g>
    </g>
  </svg>
);
